import { commonFilter, convertCase, getUniqueFilteredData, validateDecimal, validateDecimalInput } from "../../../SharedFiles/Helper/utils";
import './inventoryPosting.css';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField } from "@mui/material";
import QrContainer from "../../../SharedFiles/QRCode/qrReader";
import { useEffect, useRef, useState } from "react";
import QrCodeIcon from '@mui/icons-material/QrCode';
import { useTranslation } from 'react-i18next';

const InvPostingInput = ({ inputfieldLabel,
    openManual, openModel,
    handleQrScan, handleCloseDialog,
    hanldeScannerClick, handleSelectSuggestion,
    GetDetailsItem, setFormData,
    formData, setDropdownVisible, dropdownVisible, errorMessage,setPrintStatus}) => {

    const { t } = useTranslation();
    const [activeField, setActiveField] = useState(null); // Store the active field clicked
    const [filteredItems, setFilteredItems] = useState([]); // To store filtered results
    const dropdownRef = useRef(null);
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                // If the click is outside the dropdown, reset visibility
                setDropdownVisible(false);
            }
        };
        // Add event listener
        document.addEventListener("mousedown", handleClickOutside);
        // Cleanup the event listener when component is unmounted
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    // Handle field click to show dropdown
    const handleFieldClick = (header) => {
        
        if (header === "item_Code") {
            setActiveField(header);
          setDropdownVisible(true);
          const uniqueItemCodes = getUniqueFilteredData(GetDetailsItem,'item_Code');
          setFilteredItems(uniqueItemCodes); 
        } else if (header === "batch_Number") {
            setActiveField(header);
          setDropdownVisible(true);
          if(formData.item_Code){
            const relevantBatches =commonFilter(GetDetailsItem,'item_Code',formData.item_Code)
            setFilteredItems(relevantBatches);
          }
          else{
            setDropdownVisible(true);
            setFilteredItems(GetDetailsItem);
          }
        }
        else if(header === "item_Name"){
            setActiveField(header);
            setDropdownVisible(true);
            if(formData.item_Code){
                const relevantItemName =commonFilter(filteredItems,'item_Code',formData.item_Code)
                setFilteredItems(relevantItemName);
              }else{
            const uniqueItemName = getUniqueFilteredData(GetDetailsItem,'item_Name');
            setFilteredItems(uniqueItemName);
              }
        }
      };

      const handleInputChange = (e, header) => {
        const value = e.target.value;
        setPrintStatus(false);  // Assuming this hides the print status when searching or clearing
        let inputValue = value;
        let difference = 0;
    
        // Handle clearing the input field
        if (value === "") {
            setDropdownVisible(true);  // Show the dropdown when input is cleared
            if (header === "item_Code") {
                const uniqueItemCodes = getUniqueFilteredData(GetDetailsItem, 'item_Code');
                setFilteredItems(uniqueItemCodes);  // Show all item codes when input is cleared
            } else 
            if (header === "batch_Number") {
                if (formData.item_Code) {
                    // Filter batches based on the selected item_Code
                    const relevantBatches = commonFilter(GetDetailsItem, 'item_Code', formData.item_Code);
                    setFilteredItems(relevantBatches);  // Show batches for the selected item_Code
                } else {
                    setFilteredItems(GetDetailsItem);  // Show all batches if no item_Code is selected
                }
            }else if(header === "item_Name"){
                const uniqueItemName = getUniqueFilteredData(GetDetailsItem,'item_Name');
                setFilteredItems(uniqueItemName);
            }
        } else {
            // Handle searching when there's input
            if (header === "item_Code") {
                const filteredItemCodes = commonFilter(filteredItems, header, inputValue);
                setFilteredItems(filteredItemCodes);  // Filter items based on the input value
            } else if (header === "batch_Number") {
                const filteredBatches = commonFilter(filteredItems, header, inputValue); 
                setFilteredItems(filteredBatches);  // Filter batches based on the input value
            }else if(header === "item_Name"){
                const filtereItemName = commonFilter(filteredItems, header, inputValue); 
                setFilteredItems(filtereItemName);
            }
        }

        if (header === "Actual_Weight") {
            const { isValid, values: cleanedValue, error } = validateDecimalInput(value);
            if (isValid) {
                inputValue = cleanedValue

            } else {
                inputValue = cleanedValue;
            }
            const netWeight = formData.net_Weight ? formData.net_Weight : 0;
            if (inputValue && netWeight) {
                difference = parseFloat(inputValue) - parseFloat(netWeight);
            }
        };

        if (header === 'Remarks') {
            setFormData((prevData) => ({
                ...prevData,
                [header]: inputValue,
            }));
        } else {
            setFormData((prevData) => ({
                ...prevData,
                [header]: inputValue,
                Difference: difference?difference.toFixed(4) :'0'
            }));
        }
    };
  
    return (
        <div className="row justify-content-center">
            {openManual ? (
                inputfieldLabel.map((header, index) => (
                    <div key={index} className="col-10 col-lg-6 mb-1">
                        <div>
                            <label htmlFor={header} className="custom-label">
                              {t(convertCase(header))}
                                {(header === "batch_Number" || header === "Actual_Weight") && (
                                    <span style={{ color: "white" }}> *</span>
                                )}
                            </label>
                            <div className="input-with-icon">
                                <input
                                    type="text"
                                    id={header}
                                    className={`form-control custom-input ${errorMessage[header] ? 'error' : ''}`}
                                    placeholder={`${t((header))}`}
                                    autoComplete="off"
                                    style={{ outline: "none", boxShadow: "none" }}
                                    onChange={(e) => handleInputChange(e, header)}
                                    onClick={() => handleFieldClick(header)} // Show dropdown on click
                                    value={formData[header] || ''}
                                    disabled={header === 'net_Weight' || header === 'Difference'}
                                />
                                {errorMessage[header] && (
                                    <div className="error-message">
                                        {errorMessage[header]}
                                    </div>
                                )}
                                {header === "batch_Number" && (
                                    <QrCodeIcon
                                        onClick={() => hanldeScannerClick('scanner')}
                                        className="qr-icon"
                                        style={{
                                            color: 'grey',
                                            position: 'absolute',
                                            right: '10px',
                                            top: '50%',
                                            transform: 'translateY(-50%)',
                                            cursor: 'pointer',
                                        }}
                                    />
                                )}
                                {dropdownVisible && activeField === header && (header !== "Actual_Weight" || header !== 'Remarks') &&(
                                    <ul
                                        ref={dropdownRef}
                                        className="list-group IPDropdown position-absolute"
                                        style={{ maxHeight: "200px", overflowY: "auto", zIndex: 10 }}
                                    >
                                        {filteredItems.length > 0 ? (
                                            filteredItems.map((item, index) => (
                                                <li
                                                    key={index}
                                                    className="list-group-item  list-group-item-action"
                                                    onClick={() => handleSelectSuggestion(item, header)} // Select item
                                                    style={{ cursor: "pointer" }}
                                                >
                                                    {item[header]} {/* Display item value based on header */}
                                                </li>
                                            ))
                                        ) : (
                                            <li className="list-group-item">No results found</li>
                                        )}
                                    </ul>
                                )}
                            </div>
                        </div>
                    </div>
                ))
            ) : (
                <Dialog open={openModel}>
                    <DialogTitle className="Modal-heading">{t('Scan a Batch')}</DialogTitle>
                    <DialogContent className="custom-dialog-content">
                        <QrContainer
                        openManual={openManual}
                            elementId="Inventory-Posting"
                            onScan={handleQrScan}
                        />
                    </DialogContent>
                    <DialogActions>
                        {openManual ? (
                            <Button onClick={() => hanldeScannerClick('scanner')} color="primary">
                                Scanner
                            </Button>
                        ) : (
                            <Button onClick={() => hanldeScannerClick('Manual')}>Manual Entry</Button>
                        )}
                        <Button onClick={() => handleCloseDialog()} className="Modal-cancel">
                            Close
                        </Button>
                    </DialogActions>
                </Dialog>
            )}
        </div>
    );
}

export default InvPostingInput;
